import { Toolbar, Box, useTheme, LinearProgress, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useGetOrganizations } from '@/apis/agency/organizations/hook';
import { getCookie } from '@/utils/helperFunctions';
import { CacheKeys } from '@/utils/cacheKeys';
import {
  ONBOARDING_PROGRESS_CHANGED,
  ONBOARDING_COMPLETED
} from '@/pages/Agency/OnboardingForms/AgentReadinessForm/components/utils';

export default function BusinessOnboardingHeader() {
  const theme = useTheme();
  const location = useLocation();
  const { data: organizations } = useGetOrganizations();
  const rawProgress = getCookie(CacheKeys.onboardingFormProgress);
  const mainProgress = rawProgress ? Number(rawProgress) : 0;

  const [progress, setProgress] = useState(mainProgress);
  const searchParams = new URLSearchParams(location.search);
  const [isCompleted, setIsCompleted] = useState(searchParams.get('success') === 'true');

  useEffect(() => {
    const handleProgressChange = (event: any) => {
      setProgress(event.detail);
    };
    const handleCompleted = () => {
      setIsCompleted(true);
    };

    window.addEventListener(ONBOARDING_PROGRESS_CHANGED, handleProgressChange);
    window.addEventListener(ONBOARDING_COMPLETED, handleCompleted);

    return () => {
      window.removeEventListener(ONBOARDING_PROGRESS_CHANGED, handleProgressChange);
      window.removeEventListener(ONBOARDING_COMPLETED, handleCompleted);
    };
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get('success') === 'true') {
      setIsCompleted(true);
    }
  }, [location.search]);

  const isSecureAuth = location.pathname?.includes('login');

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.background.paper,
        boxShadow: 'none',
        borderBottom: '1px solid #E0E0E0',
        position: 'sticky',
        top: 0,
        zIndex: 1200
      }}
    >
      <Toolbar
        sx={{
          px: { xs: 2, lg: 10 },
          py: { xs: 2, lg: 2 },
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 3
        }}
      >
        <Box display='flex' alignItems='center' gap={3}>
          {isSecureAuth ? (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                '& img': {
                  height: { xs: 32, lg: 40 },
                  paddingRight: { xs: 1, lg: 1.25 }
                }
              }}
            >
              <img src={organizations?.logo_url} alt={organizations?.name} style={{ marginLeft: 'auto' }} />
            </Box>
          ) : (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                '& img': {
                  height: { xs: 32, lg: 40 }
                }
              }}
            >
              <img src={organizations?.logo_url} alt={organizations?.name} />
            </Box>
          )}

          <Box>
            <Typography sx={{ color: 'black' }} fontSize='20px' fontWeight={500}>
              Stage 2: Agent Training Info
            </Typography>
            <Typography color='text.secondary'>To map your receptionist workflows</Typography>
          </Box>
        </Box>

        {!isSecureAuth && !isCompleted && (
          <Box
            sx={{
              display: { xs: 'none', lg: 'flex' },
              alignItems: 'center',
              gap: 1.5,
              width: '240px'
            }}
          >
            <LinearProgress
              variant='determinate'
              value={progress}
              sx={{
                backgroundColor: '#E5E7EB',
                flex: 1,
                height: 6,
                borderRadius: 5
              }}
            />
            <Typography color='black' sx={{ fontSize: 12, fontWeight: 600 }}>
              {progress}%
            </Typography>
          </Box>
        )}
      </Toolbar>
    </Box>
  );
}
